import ReactGTM from 'react-gtm-module'

const init = (options = {}) => {
    const isGTMEnabled = process.env.REACT_APP_BACKEND_URL === 'https://api.interacty.me' // Only prod

    if (isGTMEnabled) {
        ReactGTM.initialize({
            gtmId: 'GTM-5PHB2BL',
        })
    }

    return isGTMEnabled
}

export default {
    init,
}
